import { Component, signal, Signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavItemModel, NavModel } from '@libs/shared/models';
import { NavigationService } from '@libs/shared/services';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { MatFabButton } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';
import { ToggleNavigationComponent } from '../toggle-navigation';

@Component({
  selector: 'ui-side-navigation',
  imports: [ToggleNavigationComponent, MatDrawerContent, MatDrawerContainer, MatFabButton, IconComponent, MatDrawer],
  templateUrl: './side-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './side-navigation.component.scss',
})
export class SideNavigationComponent {
  public mainNavigation: Signal<NavModel | undefined> = toSignal(this.navigationService.getMainNavigation());
  public current: WritableSignal<NavItemModel | undefined> = signal(undefined);

  public constructor(
    private readonly navigationService: NavigationService,
  ) {
  }
}
